import { Component, Input } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'skeletor-clasif',
  standalone: true,
  imports: [CommonModule, NgFor, SkeletonModule],
  templateUrl: './clasif.template.component.html',
  styleUrls: ['./clasif.template.component.scss']
})
export class SkeletorClasifTemplateComponent {
  @Input() items: number = 6;
  get rows() { return Array.from({ length: this.items }); }
}

